var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#338dc7;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.83,19.77a4.16,4.16,0,1,0-4.159,4.16A4.164,4.164,0,0,0,13.83,19.77Zm-6.72,0a2.56,2.56,0,1,1,2.56,2.56A2.563,2.563,0,0,1,7.11,19.77Zm12.17.169-.263.318c-.284.488-3.937,6.567-9.377,6.567-3.278,0-5.914-2.222-7.549-4.087L1.709,22.3l.871-1.472.728.829C4.729,23.276,6.981,25.2,9.639,25.2c3.81,0,6.768-3.914,7.738-5.372-.835-1.322-3.789-5.5-7.767-5.5-4.325,0-7.372,4.881-7.938,5.86l-.013.021L.984,21.5l-.95-1.637.2-.4c.148-.275,3.676-6.743,9.372-6.743s9.278,6.463,9.428,6.738l.214.393-.012.02Z",
    transform: "translate(87.967 457.284)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(86 465)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEye);
export default __webpack_public_path__ + "static/media/icons-eye.e69d9065.svg";
export { ForwardRef as ReactComponent };